import React from 'react'

import './App.css';
import 'semantic-ui-css/semantic.min.css'

import NavigationBar from './views/navigationbar'

import Home from './views/home/home'
import About from './views/about/about'
import Useradmin from './views/useradmin/useradmin'
import Login from './views/login/login';


import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";


function App() {

  const token = localStorage.getItem('accessToken');
  const puzzelToken = localStorage.getItem('puzzelToken');

  return (
    <Router>
      <div className="App">
        {
        (token || puzzelToken) &&
        <>
        <NavigationBar className="Navigation" applicationname="Puzzel Administration"></NavigationBar>
        
            <Switch>
              <Route exact path="/">
                <Home/>
              </Route>

              <Route path="/useradministration">
                <Useradmin></Useradmin>  
              </Route>

              <Route path="/about">
                <About />
              </Route>
            </Switch>
        </>
        }
        {
          (!token || !puzzelToken) && <Login/>
        }
      </div>
    </Router>

    
  );
}

export default App;
